module.exports = __webpack_public_path__ + "img/ec07b74.png";